// extracted by mini-css-extract-plugin
export default {"container":"heroSection_container__A0wsX","heading":"heroSection_heading__lZeh7","item":"heroSection_item__J2QLm","bold":"heroSection_bold__qmlmi"};